import { HttpErrorResponse } from "@angular/common/http";
import { createActionGroup, props } from "@ngrx/store";
import { StoreActionStatuses } from "@utility/state";
import { Remitter } from "../models/remitter.model";
const LOAD_REMITTERS_ACTION = "Load Remitters";

export const remitterActions = createActionGroup({
	source: "Remitters",
	events: {
		[LOAD_REMITTERS_ACTION]: props<{ serviceEntityId: string; clientId: string }>(),
		[`${LOAD_REMITTERS_ACTION} ${StoreActionStatuses.SUCCESS}`]: props<{ remitters: Remitter[] }>(),
		[`${LOAD_REMITTERS_ACTION} ${StoreActionStatuses.FAILURE}`]: props<{ error: HttpErrorResponse }>()
	}
});

export const { loadRemitters, loadRemittersSuccess, loadRemittersFailure } = remitterActions;
